import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import API from '../../utils/api';

const pad = n => String(n).padStart(2, '0');

function Countdown({ initial }) {
  const [time, setTime] = useState(initial || [0,0,0]);
  useState(() => {
    if (!initial) return;
    const id = setInterval(() => {
      setTime(([h,m,s]) => {
        s--; if(s<0){s=59;m--} if(m<0){m=59;h--} if(h<0) return [0,0,0];
        return [h,m,s];
      });
    }, 1000);
    return () => clearInterval(id);
  });
  const [h,m,s] = time;
  return (
    <div style={{ display:'flex', alignItems:'center', gap:4, color:'#C0392B', fontSize:11, fontWeight:700 }}>
      ⏱ <span className="countdown-pip">{pad(h)}</span>h <span className="countdown-pip">{pad(m)}</span>m <span className="countdown-pip">{pad(s)}</span>s
    </div>
  );
}

export default function ListingCard({ listing, delay = 0 }) {
  const navigate = useNavigate();
  const { user }  = useAuth();
  const [saved, setSaved] = useState(listing.isSaved || false);
  const [saving, setSaving] = useState(false);
  const [hoursRemaining, setHoursRemaining] = useState(null);

  const { id, slug, title, listing_type, price, current_bid, starting_bid, unit, primary_image, category_label, category_icon, rating_avg, rating_count, dist, location_city, location_state, badgeColor, countdown, promotion } = listing;
  const listingPath = `/listing/${slug || id}`;
  const displayPrice = listing_type === 'auction' ? (current_bid || starting_bid || 0) : price;

  const badge = listing_type === 'rent' ? 'For Rent' : listing_type === 'auction' ? 'Live Bid' : listing_type === 'barter' ? 'Barter' : listing_type === 'free' ? 'Free' : 'For Sale';
  const color = listing_type === 'rent' ? '#1A5276' : listing_type === 'auction' ? '#C0392B' : listing_type === 'barter' ? '#6A1B9A' : listing_type === 'free' ? '#2E7D32' : '#2D7A3A';
  const actionLabel = listing_type === 'rent' ? 'Book Now' : listing_type === 'auction' ? 'Bid' : listing_type === 'barter' ? 'Trade' : listing_type === 'free' ? 'Claim' : 'Buy';

  useState(() => {
    if (!promotion || !promotion.expires_at) return;
    const updateCountdown = () => {
      const now = new Date().getTime();
      const expires = new Date(promotion.expires_at).getTime();
      const diff = Math.max(0, expires - now);
      const hours = Math.floor(diff / (1000 * 60 * 60));
      setHoursRemaining(hours);
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 60000);
    return () => clearInterval(interval);
  });

  const handleSave = async (e) => {
    e.stopPropagation();
    if (!user) { navigate('/login'); return; }
    setSaving(true);
    try {
      const { data } = await API.post(`/listings/${id}/save`);
      setSaved(data.saved);
    } catch {}
    setSaving(false);
  };

  return (
    <div
      className="listing-card fade-up"
      style={{ animationDelay: `${delay}s` }}
      onClick={() => navigate(listingPath)}
    >
      <div className="lcard-img">
        <div className="lcard-img-inner" style={{ background: primary_image ? undefined : '#1C1C1C' }}>
          {primary_image
            ? <img src={`${process.env.REACT_APP_API_URL?.replace('/api','')}${primary_image}`} alt={title} />
            : <span style={{ fontSize: 60, filter: 'drop-shadow(0 4px 10px rgba(0,0,0,.3))' }}>📦</span>
          }
        </div>
        {promotion && hoursRemaining > 0 && (
          <div style={{
            position: 'absolute',
            top: 8,
            left: 8,
            background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
            color: '#1C1C1C',
            padding: '6px 12px',
            borderRadius: 20,
            fontSize: 11,
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}>
            ⭐ Promoted {hoursRemaining}h
          </div>
        )}
        <div className="lcard-badge" style={{ background: color }}>{badge}</div>
        <button className="lcard-fav" onClick={handleSave} disabled={saving}>
          {saved ? '❤️' : '🤍'}
        </button>
      </div>

      <div className="lcard-body">
        <div className="lcard-cat">{category_icon} {category_label}</div>
        <div className="lcard-title">{title}</div>

        {listing_type === 'auction' && countdown && <Countdown initial={countdown} />}

        <div className="lcard-meta">
          <span style={{ color: '#C9930A' }}>★</span>
          <span style={{ fontWeight: 600, color: '#1A1A1A' }}>{parseFloat(rating_avg || 0).toFixed(1)}</span>
          <span>({rating_count || 0})</span>
          <span style={{ color: '#E8E2DC' }}>·</span>
          <span>📍 {dist || `${location_city}, ${location_state}`}</span>
        </div>

        <div className="lcard-footer">
          <div>
            {listing_type === 'auction' && (
              <span style={{ fontSize: 10, fontWeight: 700, color: '#C0392B', textTransform: 'uppercase', letterSpacing: 1, display: 'block', marginBottom: 1 }}>Current bid</span>
            )}
            {listing_type === 'free'
              ? <span className="lcard-price" style={{ color:'#2E7D32' }}>Free</span>
              : listing_type === 'barter'
              ? <span className="lcard-price" style={{ color:'#6A1B9A', fontSize:14 }}>Trade</span>
              : <><span className="lcard-price">${parseFloat(displayPrice || 0).toLocaleString()}</span><span className="lcard-unit">{listing_type === 'rent' ? '/day' : ''}</span></>
            }
          </div>
          <button
            className="btn btn-sm"
            style={{ background: color, color: 'white', border: 'none', borderRadius: 7, padding: '7px 14px', fontSize: 12, fontWeight: 700 }}
            onClick={e => { e.stopPropagation(); navigate(listingPath); }}
          >{actionLabel}</button>
        </div>
      </div>
    </div>
  );
}
